import React from "react";
import "./Services.css";
import Card2 from "../../../../Components/Cards/Card2";
import Accounting from "../../../../assets/images/services-accounting.png";
import Compliance from "../../../../assets/images/services-compliance.png";
import Tax from "../../../../assets/images/services-tax.png";
import Writing from "../../../../assets/images/services-writing.png";
import Shape1 from "../../../../assets/images/services-shape1.png";
import Dots from "../../../../assets/images/services-dots.png";
const Services = () => {
  return (
    <div className="services__section">
      <img src={Shape1} alt="" className="services__section_shape1" />
      <img src={Dots} alt="" className="services__section_dots" />
      <div className="services__section_headingwrap">
        <div className="services__section_headingtitle">VIEW</div>
        <div className="services__section_heading">
          <span className="services__section_headingblack">Our</span>{" "}
          <span className="services__section_headinggreen">Services</span>
        </div>
      </div>
      <div className="services__section_body">
        <div className="services__section_card">
          <Card2
            image={Tax}
            heading="Tax"
            description="Small business tax return preparation or Individual tax return preparation filing instructions is a core service offered to our clients."
            links={[
              { text: "Individual Taxes", url: "#" },
              { text: "Corporate Taxes", url: "#" },
            ]}
            backgroundColor="rgba(0, 142, 255, 0.15)"
          />
        </div>
        <div className="services__section_card">
          <Card2
            image={Writing}
            heading="Book keeping / Write-up"
            description="Maintaining accurate financial records can be the difference between an extraordinary success and at Serene Tax, we record, track and maintain a general ledger for your transaction."
            backgroundColor="rgba(6, 163, 170, 0.15)"
          />
        </div>
        <div className="services__section_card">
          <Card2
            image={Accounting}
            heading="Accounting Services"
            description="From start-ups to established enterprises, businesses rely on accurate and insightful financial information in order to maintain profitability and capitalize on new opportunities."
            backgroundColor="rgba(163, 237, 236, 0.15)"
          />
        </div>
        <div className="services__section_card">
          {" "}
          <Card2
            image={Compliance}
            heading="Tax Compliance"
            description="Tax return preparation is a complex process that calls for sophisticated assistance and technical knowledge. As tax professionals, we are fully versed in the tax law and are prepared to put our experience to work for you."
            backgroundColor="rgba(122, 67, 238, 0.1)"
          />
        </div>
      </div>
    </div>
  );
};

export default Services;
